import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { eventEmitter } from "../EventEmitter";
import { downloadFile, shortlistedPropertyApi } from "../../api/commonApi";
import generateSlug from "../common/generateSlug";
import AlertModal from "../modals/AlertModal";
const Wishlisted = ({
  data,
  wishlist,
  user,
  token,
  handleDispatch,
  themeValue='dark',
  handleOpenModal
}) => {
  

  const theme = {
    dark: {primary: '#1B4E9B', secondary:'none',default:'#343434'},
    light: {primary: '#FFF', secondary:'none',default:'#fff'},
  };
  
  const themeSelected = theme[themeValue]
  
   


  const propertyIds = Array.isArray(data?.property_ids)
  ? data.property_ids.map(String) // Convert all to strings
  : Array.isArray(data?.[0]?.property_ids)
    ? data[0].property_ids.map(String) 
    : String(data?.property_ids || data?.[0]?.property_ids || "")
        .split(",")
        .map(id => id.trim())
        .filter(id => id); // Remove empty values

const isWishlisted = wishlist.map(String).some(value => propertyIds.includes(value));
  const [openModal, setOpenModal] = useState(false);
  // alert(JSON.stringify(user));



  const handleShortlist = async (id, status) => {
    const result = await shortlistedPropertyApi({ id, status, user, token });
  
    if (result?.loginRequired) {
      eventEmitter.emit('loginFirst', true);
      return;
    }
  
    if (result?.status) {
      handleDispatch();
    } else if (result?.error) {
      alert("Something Went Wrong. Please try again.");
    }
  };



//   const shortlistedProperty = async (id,status) => {

//  if (!user?.data?.id) {
//   eventEmitter.emit('loginFirst', true);
//   return
// } 

  
//     try {
//       const formData = new FormData();

//       //alert(user?.data?.id);
//       formData.append("property_id", id);
//       formData.append("user_id", user?.data?.id);
//       formData.append("name", user?.data?.name);
//       formData.append("mobile", user?.data?.mobile);
//       formData.append("activity_category", "shortlisted_property");
//       formData.append("status", status);
   
//       //alert(JSON.stringify(formData));
//       // Example API call to save the profile data including the image
//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}/shortlistedProperty`, // Replace with your API URL
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`, // Attach Bearer token
//             "Content-Type": "application/json", // Set correct content type for file upload
//           },
//         }
//       );

//       if (response.data.status) {
//         handleDispatch();
       
//       }
//     } catch (error) {
//       console.error("Error updating:", error);
//       alert("Something Went Wrong. Please try again.");
//     }
//   };

  // Generate WhatsApp Share Link
  const shareOnWhatsApp = () => {
    const message = `🏡 *${"buy this property"}*\n\n${"this is the description"}\n🔗 ${"https://dreamwebsite.rusofterp.in/buy-vikrant-heights-mansarovar-sector-7-mansarovar-jaipur-rajasthan-pid-1"}`;
    const whatsappURL = `https://wa.me/?text=${encodeURIComponent(message)}`;

    window.open(whatsappURL, "_blank"); // Open in new tab
  };

const sharePropertyLink = async () => {

 
  const longUrl =  `${window.location.origin}${generateSlug(data)}`;

  try {
    // Step 1: Request backend to save and return short URL
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/saveTinyUrl`, {
      original_url: longUrl,
    });
    

    const shortCode = response.data?.short_code;
    const shortUrl = `${window.location.origin}/${shortCode}`;

    // Step 2: Copy to clipboard
    await navigator.clipboard.writeText(shortUrl);

    // Step 3: Show success alert
    //alert("✅ Short URL copied to clipboard:\n" + shortUrl);
    handleOpenModal();
  } catch (error) {
    console.error("❌ Error generating short URL:", error);
    alert("❌ Failed to generate short URL. Please try again.");
  }
};
  


  const downloadBrochure = (item) => {

    const pdfUrl = item?.image;
    const fileName = `${item?.project_name || "Brochure"}.pdf`;
    downloadFile(pdfUrl, fileName);
  };

  return (
    <>

    {data?.brochure?.length > 0 && (
      <div
        onClick={(e) => { e.preventDefault(); 
          e.stopPropagation(); // Prevent div click
          downloadBrochure(data?.brochure[0])}}
        className="jump-icon"
        style={{ animationDelay: "0.2s", cursor: "pointer" }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.25 13.375H13.2588M13.6 10.75H14.125C14.9404 10.75 15.3481 10.75 15.6697 10.8832C16.0985 11.0608 16.4392 11.4015 16.6168 11.8303C16.75 12.1519 16.75 12.5596 16.75 13.375C16.75 14.1904 16.75 14.5981 16.6168 14.9197C16.4392 15.3485 16.0985 15.6892 15.6697 15.8668C15.3481 16 14.9404 16 14.125 16H3.625C2.80961 16 2.40191 16 2.0803 15.8668C1.65151 15.6892 1.31083 15.3485 1.13321 14.9197C1 14.5981 1 14.1904 1 13.375C1 12.5596 1 12.1519 1.13321 11.8303C1.31083 11.4015 1.65151 11.0608 2.0803 10.8832C2.40191 10.75 2.80961 10.75 3.625 10.75H4.15M8.875 11.625V2M8.875 11.625L6.25 9M8.875 11.625L11.5 9"
            stroke="#343434"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    )}
      <Link 
    
      onClick={(e) => { e.preventDefault(); 
          e.stopPropagation(); // Prevent div click
          sharePropertyLink(e)}}
      >
        <div className="jump-icon" style={{ animationDelay: "0.4s" }}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill={isWishlisted ? themeSelected.primary : themeSelected.secondary }
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.3746 3.66666C10.3746 2.1939 11.5932 1 13.0964 1C14.5996 1 15.8182 2.1939 15.8182 3.66666C15.8182 5.13942 14.5996 6.33334 13.0964 6.33334C12.3374 6.33334 11.6514 6.02877 11.1583 5.53878L7.39047 8.0636C7.42526 8.234 7.44355 8.41 7.44355 8.58976C7.44355 8.94576 7.37202 9.28608 7.24245 9.59712L11.3738 12.2686C11.8428 11.8929 12.4427 11.6666 13.0964 11.6666C14.5996 11.6666 15.8182 12.8606 15.8182 14.3334C15.8182 15.8061 14.5996 17 13.0964 17C11.5932 17 10.3746 15.8061 10.3746 14.3334C10.3746 13.9476 10.4585 13.5804 10.6093 13.2489L6.51129 10.599C6.03325 11.0078 5.40708 11.2564 4.72176 11.2564C3.21858 11.2564 2 10.0625 2 8.58976C2 7.11698 3.21858 5.92308 4.72176 5.92308C5.58614 5.92308 6.3556 6.3178 6.8538 6.93214L10.5054 4.48514C10.4205 4.22687 10.3746 3.95168 10.3746 3.66666Z"
              fill={isWishlisted ? themeSelected.primary : themeSelected.default }
            />
          </svg>
        </div>
      </Link>
      <div
        onClick={(e) => {
        e.preventDefault(); 
        e.stopPropagation(); // Prevent div click
        handleShortlist(propertyIds, (isWishlisted ? 0 : 1) )}}
        className="jump-icon"
        style={{ animationDelay: "0.6s" }}
      >
       
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          // fill={wishlist.includes(data.id) ? "#1B4E9B" : "none"}
          fill={isWishlisted ? themeSelected.primary : themeSelected.secondary }
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.465 15.6077C9.21 15.6977 8.79 15.6977 8.535 15.6077C6.36 14.8652 1.5 11.7677 1.5 6.51769C1.5 4.20019 3.3675 2.3252 5.67 2.3252C7.035 2.3252 8.2425 2.9852 9 4.0052C9.38533 3.4846 9.88723 3.06149 10.4655 2.76975C11.0438 2.47802 11.6823 2.32576 12.33 2.3252C14.6325 2.3252 16.5 4.20019 16.5 6.51769C16.5 11.7677 11.64 14.8652 9.465 15.6077Z"
            // stroke={wishlist.includes(data.id) ? "#1B4E9B" : "#343434"}
            stroke={isWishlisted ? themeSelected.primary : themeSelected.default }
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        {/* {JSON.stringify(wishlist) +'and'+ JSON.stringify(propertyIds) } */}
        
      </div>

      {/* {showModal && 
      
        <AlertModal />
      } */}
    </>
  );
};

export default Wishlisted;
